/* eslint-disable no-param-reassign */
import { Reducer } from 'redux';
import produce from 'immer';

import { IListState } from './types';

const INITIAL_STATE: IListState = {
  list: [],
  loading: true,
};

const userInfo: Reducer<IListState> = (state = INITIAL_STATE, action) => {
  // eslint-disable-next-line consistent-return
  return produce(state, draft => {
    switch (action.type) {
      case 'ADD_LIST_INFO': {
        const { apiListInfo } = action.payload;

        draft = {
          list: apiListInfo,
          loading: false,
        };

        return draft;
      }
      case 'REMOVE_LIST_INFO': {
        draft = {
          list: [],
          loading: false,
        };

        return draft;
      }

      default: {
        // return INITIAL_STATE;
        break;
      }
    }
  });
};

export default userInfo;
